import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiHandlerService } from "./services/api-handler.service";
import { ToasterService } from "./services/toaster.service";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CmnFunctionService } from "./services/cmn-function.service";
import { StorageService } from "./services/storage.service";
import { TokenInterceptorService } from './services/token-interceptor.service';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AuthGuard } from './services/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import * as firebase from 'firebase';
import { ConfirmationComponent } from './modal/confirmation/confirmation.component';
import { SettingsComponent } from './components/settings/settings.component';
import { AddSosContactComponent } from './components/add-sos-contact/add-sos-contact.component';
import { DatePipe } from '@angular/common';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { CustomPhonePipe } from './pipes/custom-data-filters.pipe';
import { PhoneMaskDirective } from './directives/phone-mask.directive';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDsL75H98RWvkQdlXBRyUZ5NxKsYcG6CUI",
//   authDomain: "ornate-unity-287806.firebaseapp.com",
//   databaseURL: "https://ornate-unity-287806.firebaseio.com",
//   projectId: "ornate-unity-287806",
//   storageBucket: "ornate-unity-287806.appspot.com",
//   messagingSenderId: "178999680630",
//   appId: "1:178999680630:web:d4dfaa4f56d22ce5664957",
//   measurementId: "G-MMBNT9C2X3"
// };

//Office Account config
// var firebaseConfig = {
//   apiKey: "AIzaSyC9WtoX0KCtCak4ExZ2jJDzFjmT3eRGAfU",
//   authDomain: "wooffer-2a835.firebaseapp.com",
//   databaseURL: "https://wooffer-2a835.firebaseio.com",
//   projectId: "wooffer-2a835",
//   storageBucket: "wooffer-2a835.appspot.com",
//   messagingSenderId: "265029724916",
//   appId: "1:265029724916:web:efa4b2eb760a9d36ea8ca1",
//   measurementId: "G-SE61D8K2ZF"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDZkIOdbI1Ui-8PQgE8pRsDX-d14CdqtcI",
  authDomain: "wooffertechnology-2b6b9.firebaseapp.com",
  projectId: "wooffertechnology-2b6b9",
  storageBucket: "wooffertechnology-2b6b9.firebasestorage.app",
  messagingSenderId: "1036795629906",
  appId: "1:1036795629906:web:437e5332f820ef57b4ea8b",
  measurementId: "G-MWN2KGC5ZR"
};

firebase.initializeApp(firebaseConfig);

@NgModule({
  declarations: [PageNotFoundComponent, ConfirmationComponent, SettingsComponent, AddSosContactComponent, CustomPhonePipe, PhoneMaskDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    GooglePlaceModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule, // Only required for database features
    AngularFireAuthModule, // Only required for auth features,
    AngularFireStorageModule // Only required for storage features
  ],
  exports: [
    CustomPhonePipe,
    PhoneMaskDirective
  ],
  providers: [
    ApiHandlerService,
    ToasterService,
    CmnFunctionService,
    AuthGuard,
    DatePipe,
    CustomPhonePipe,
    StorageService,
    TokenInterceptorService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true }]
})
export class SharedModule { }
